import script from "./HeaderLink.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderLink.vue?vue&type=script&setup=true&lang=js"

import "./HeaderLink.vue?vue&type=style&index=0&id=08ec1dd3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08ec1dd3"]])

export default __exports__